<template>
  <BaseIcon
    :active="active"
    :dark-mode="darkMode"
    :width="width"
    :height="height"
    :svg-path="'M7.70996 3.96022L5.24996 6.42247L4.28996 5.46247L3.20996 6.54022L4.70996 8.04022L5.24996 8.55472L5.78996 8.03947L8.78996 5.03947L7.70996 3.95947V3.96022ZM11.25 5.25022V6.75022H21V5.25022H11.25ZM7.70996 9.96022L5.24996 12.4232L4.28996 11.4602L3.20996 12.5402L4.70996 14.0402L5.24996 14.5547L5.78996 14.0395L8.78996 11.0395L7.70996 9.96022ZM11.25 11.2502V12.7502H21V11.2502H11.25ZM7.70996 15.9602L5.24996 18.4225L4.28996 17.4625L3.20996 18.5402L4.70996 20.0402L5.24996 20.5547L5.78996 20.0395L8.78996 17.0395L7.70996 15.9595V15.9602ZM11.25 17.2502V18.7502H21V17.2502H11.25Z'" />
</template>

<script>
import BaseIcon from "./BaseIcon.vue"
export default {
  components: {
    BaseIcon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 22
    },
    height: {
      type: [Number, String],
      default: 22
    }
  }
}
</script>
